module.exports = __webpack_public_path__ + "static/media/Finansii-Mobile-en.39131975.jpg";